import GenericVideoDialog from "./GeneralVideoDialog";
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {DeclineStudentDialogId} from "./VideoChat";

@inject('videoChatStore')
@observer
export class DeclineStudentDialog extends Component {
    render() {
        const {isOpen, closeDialog, handleOnClose, handleCancel, handleAccept, videoChatStore} = this.props;
        return <GenericVideoDialog dialogId={DeclineStudentDialogId} isOpen={isOpen}
                                   onClose={closeDialog}
                                   titleKey={'video.chat.student.student.declined.title'}
                                   textKey={'video.chat.student.student.declined.text'}
                                   itemName={videoChatStore.lastDeclinedUser?.name}
                                   buttonKey={'teacher.dismiss'}
                                   cancelButtonText={'teacher.send'}
                                   handleCancel={handleCancel}
                                   handleClose={handleOnClose}
                                   handleAccept={handleAccept}
        />
    }
}